import React from 'react';
import { motion } from 'framer-motion';
import ImageSlider from './ImageSlider';

const PRODUCTS = [
  { icon: '👟', title: 'Safety Shoes',              desc: 'Steel-toe and composite safety footwear for industrial and construction environments.' },
  { icon: '👔', title: 'Boiler Suits & Uniforms',   desc: 'Flame-retardant and high-visibility workwear suits for all site personnel.' },
  { icon: '🧤', title: 'Knitted Gloves',             desc: 'Cut-resistant and general-purpose protective gloves for varied industrial tasks.' },
  { icon: '🛡️', title: 'Lubricants, Dust Masks & More', desc: 'A wide range of PPE consumables including respiratory protection and industrial lubricants.' },
];

const container = { animate: { transition: { staggerChildren: 0.12 } } };
const item = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

export default function Products() {
  return (
    <section id="products" className="section-pad bg-brand-surface relative overflow-hidden">
      <div className="container-xl relative z-10">
        <motion.span
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          className="section-label"
        >
          <span className="w-8 h-px bg-brand-orange" /> Safety Equipment
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="font-heading font-black text-4xl sm:text-5xl text-brand-heading mb-4 leading-tight"
        >
          OUR <span className="text-gradient">PRODUCTS</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.2 }}
          className="text-brand-subtle max-w-xl mb-14"
        >
          We supply premium safety equipment and PPE to construction and industrial sites across Tamil Nadu.
        </motion.p>

        <motion.div
          variants={container}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {PRODUCTS.map((p) => (
            <motion.div
              key={p.title}
              variants={item}
              whileHover={{ y: -8, transition: { duration: 0.25 } }}
              className="group card rounded-2xl p-7 flex flex-col items-start hover:border-orange-200 hover:shadow-card-hover transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-2xl bg-orange-50 flex items-center justify-center text-3xl mb-5 group-hover:scale-110 group-hover:bg-orange-100 transition-all duration-300">
                {p.icon}
              </div>
              <h3 className="font-heading font-bold text-brand-heading text-lg mb-2 group-hover:text-brand-orange transition-colors duration-300">{p.title}</h3>
              <p className="text-brand-subtle text-sm leading-relaxed flex-1">{p.desc}</p>
              <div className="mt-5 flex items-center gap-1 text-brand-orange text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                Enquire now <span>→</span>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}
          className="mt-10 text-center"
        >
          <a href="#contact" className="btn-primary">
            Request Product Catalogue ↗
          </a>
        </motion.div>

        <div className="mt-12">
          <ImageSlider page="products" />
        </div>
      </div>
    </section>
  );
}
